import gql from "graphql-tag";

import {type GqlFetchFn} from "@khan/data-gql";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";
import {Errors, KAError} from "@khan/logging";

import type {signupResendVerificationEmailMutationType} from "./__graphql-types__/index.ts";

export const SIGNUP_RESEND_VERIFICATION_EMAIL_MUTATION: GqlOperation<
    signupResendVerificationEmailMutationType["response"],
    signupResendVerificationEmailMutationType["variables"]
> = gqlOp(gql`
    mutation signupResendVerificationEmailMutation {
        signupResendVerificationEmail {
            error {
                code
            }
        }
    }
`);

export async function signupResendVerificationEmail(
    gqlFetch: GqlFetchFn,
): Promise<boolean> {
    try {
        const data = await gqlFetch(SIGNUP_RESEND_VERIFICATION_EMAIL_MUTATION);

        if (data?.signupResendVerificationEmail?.error) {
            throw new KAError(
                data.signupResendVerificationEmail.error.code,
                Errors.Internal,
            );
        }

        // Verification email sent.
        return true;
    } catch (error: any) {
        // We handle the exception thrown from within the mutation success
        // handler.
        if (error instanceof KAError) {
            throw error;
        }

        // Otherwise we throw a generic error.
        throw new KAError(
            "Failed to resend the verification email",
            Errors.Internal,
        );
    }
}
